import { __rest, __assign } from '../../../external/tslib/tslib.es6.mjs.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import styles from './FieldLabel.module.scss.js';

var FieldLabel = function (_a) {
    var _b;
    var children = _a.children, htmlFor = _a.htmlFor, size = _a.size, className = _a.className; _a.style; var required = _a.required, props = __rest(_a, ["children", "htmlFor", "size", "className", "style", "required"]);
    return (jsxs("label", __assign({ htmlFor: htmlFor, className: clsx(styles['fieldLabel'], (_b = {},
            _b[styles.fieldLabelLarge] = size === 'm' || size === 'l',
            _b), className) }, props, { children: [children, required && jsx("span", __assign({ className: styles.fieldLabelStar }, { children: " *" }))] })));
};

export { FieldLabel };
